import { render, staticRenderFns } from "./WeeklyAvailability.vue?vue&type=template&id=10889eca&scoped=true&"
import script from "./WeeklyAvailability.vue?vue&type=script&lang=js&"
export * from "./WeeklyAvailability.vue?vue&type=script&lang=js&"
import style0 from "./WeeklyAvailability.vue?vue&type=style&index=0&id=10889eca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10889eca",
  null
  
)

export default component.exports